<template>
  <div class="ap-index">
    <el-carousel class="slider" ref="slider" :height="height">
      <el-carousel-item v-for="it in imgData" :key="it.url">
        <img class="img" :src="it.url" alt />
      </el-carousel-item>
    </el-carousel>
    <div class="main-width">
      <ul class="tabs">
        <li class="item" :class="{'active': view=='NumberSearch'}" @click="view='NumberSearch'">以零件编号查询</li>
        <li class="item" :class="{'active': view=='VehicleSearch'}" @click="view='VehicleSearch'">以车型查询</li>
        <li class="item" :class="{'active': view=='GenArtSearch'}" @click="view='GenArtSearch'">以零件类目查询</li>
      </ul>
      <component :is="view"></component>
    </div>
  </div>
</template>

<script>
import NumberSearch from "./index/NumberSearch.vue";
import VehicleSearch from "./index/VehicleSearch.vue";
import GenArtSearch from "./index/GenArtSearch.vue";

export default {
  components: {
    NumberSearch,
    VehicleSearch,
    GenArtSearch
  },
  data() {
    return {
      view: "NumberSearch",
      height: "0px",
      imgData: [
        { url: require("@assets/images/banner01.jpg") },
        { url: require("@assets/images/banner02.jpg") },
        { url: require("@assets/images/banner03.jpg") }
      ]
    };
  },
  mounted() {
    this.initHeight();
  },
  methods: {
    initHeight() {
      this.height = parseInt(this.$refs.slider.$el.offsetWidth * (378 / 1920)) + "px";
      window.addEventListener("resize", () => {
        let w = this.$refs.slider.$el.offsetWidth;
        if (w < 1366) w = 1366;
        if (w > 2560) w = 2560;
        this.height = parseInt(w * (378 / 1920)) + "px";
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ap-index {
  .slider {
    z-index: -1;
    .img {
      width: 100%;
      height: 100%;
    }
  }
  .main-width {
    z-index: 1;
    margin: -40px auto 40px;
    .tabs {
      overflow: hidden;
      margin-bottom: 20px;
      .item {
        cursor: pointer;
        float: left;
        padding: 0 30px;
        line-height: 40px;
        background: #f6f7f9;
        border-left: 1px solid #e4e4e4;
        &:first-child {
          border-left: none;
        }
        &.active {
          background: #fff;
          font-weight: bolder;
          color: #f00;
        }
      }
    }
  }
}
</style>